import { Helmet } from "react-helmet-async";
import { site } from "./data";

type SeoProps = {
  title: string;
  description: string;
  path?: string;
  type?: "website" | "article";
  schema?: Record<string, unknown> | Record<string, unknown>[];
  noIndex?: boolean;
};

export function SEO({ title, description, path = "/", type = "website", schema, noIndex }: SeoProps) {
  const canonical = new URL(path, site.url).toString();
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:image" content={`${site.url}/og-default.svg`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${site.url}/og-default.svg`} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      {schemas.map((item,index)=><script key={index} type="application/ld+json">{JSON.stringify(item)}</script>)}
    </Helmet>
  );
}

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: site.name,
  url: site.url,
  description: site.promise,
  areaServed: "Worldwide",
  email: site.email,
  telephone: site.phone,
  knowsAbout: [
    "Website design", "Website modernization", "Managed website hosting", "Business email",
    "Search engine optimization", "Digital marketing", "Social media marketing", "Online advertising",
    "Generative AI agents", "Workflow automation", "Business templates", "Digital business tools"
  ]
};
